import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Custom key-value data for reporting and integrations.
 */
export const schema = z
  .object({
    program: z.string().describe('Program name identifier (e.g., "GMA")').optional(),
    dealer_code: z.string().describe('Dealer code identifier for external systems').optional(),
    billing_program: z.string().describe('Billing program identifier for invoicing categorization').optional(),
    gma_market: z.string().describe('GMA market code (e.g., "GX4", "GC2")').optional(),
    gma_region: z.string().describe('GMA region code (e.g., "SC", "EA", "WE")').optional(),
    gma_program: z.string().describe('GMA program name for reporting').optional(),
    gma_dealer_cd: z.string().describe('GMA dealer code (e.g., "TX712")').optional(),
    gma_retailer_name: z.string().describe('GMA retailer display name for reports').optional(),
  })
  .passthrough() // Allow additional custom key-value pairs
  .describe(
    'Custom key-value data for reporting and integrations. Keys are auto-formatted: lowercase with spaces to underscores.'
  );

export type CustomerValues = z.infer<typeof schema>;

export const definition = define({
  key: 'customer_values',
  schema,
  label: 'Custom Settings',
  description:
    'Custom key-value data for reporting and integrations. Keys are auto-formatted: lowercase with spaces to underscores.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.CUSTOM_SETTINGS.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
    LEVELS.MOVE,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: {},
});
